import React, { Component } from 'react';
import PropTypes from 'prop-types';

import styles from './index.module.css';

const WIDE_TYPES = ['bedrock', 'waterTable', 'temp'];
const ULTRAWIDE_TYPES = ['interview_', 'budget'];
const SUPERWIDE_TYPES = ['documents'];

class Popup extends Component {
  render() {
    let props = this.props;

    return (
      <div className={`${styles.modal} ${props.type ? '' : styles.invisible}`}>
        <div className={styles.backdrop} />
        <div
          className={`${styles.content} ${props.type ? styles.centered : ''}
           ${
             WIDE_TYPES.some(type => props.type.indexOf(type) > -1)
               ? styles.wide
               : ''
           }
           ${
             ULTRAWIDE_TYPES.some(type => props.type.indexOf(type) > -1)
               ? styles.ultraWide
               : ''
           }
           ${
             SUPERWIDE_TYPES.some(type => props.type.indexOf(type) > -1)
               ? styles.superWide
               : ''
           }`}>
          {props.children}
        </div>
      </div>
    );
  }
}

Popup.defaultProps = {
  type: '',
};

Popup.propTypes = {
  type: PropTypes.string,
};

export default Popup;
